import { Component } from '@theme/component';
import { OPEN_CEP_POPUP_EVENT, formatCep, getStoredCep, CEP_CHANGED_EVENT } from '@theme/cep-session';

/**
 * @typedef {object} HeaderCepRefs
 * @property {HTMLElement} cepLabel
 */

class HeaderCep extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#updateLabel();
    document.addEventListener(CEP_CHANGED_EVENT, this.#updateLabel);
  }

  disconnectedCallback() {
    document.removeEventListener(CEP_CHANGED_EVENT, this.#updateLabel);
    super.disconnectedCallback();
  }

  #updateLabel = () => {
    const label = this.refs.cepLabel;
    if (!label) return;

    const cep = getStoredCep();
    label.textContent = cep ? formatCep(cep) : label.dataset.placeholder || '';
    this.toggleAttribute('data-has-cep', Boolean(cep));
  };

  openPopup() {
    document.dispatchEvent(new CustomEvent(OPEN_CEP_POPUP_EVENT));
  }
}

if (!customElements.get('header-cep')) {
  customElements.define('header-cep', HeaderCep);
}
